
import { formatDate } from '@/lib/utils';

interface PayslipFooterProps {
  generatedDate: string;
}

export const PayslipFooter = ({ generatedDate }: PayslipFooterProps) => {
  return (
    <div className="mt-6 p-4 text-center text-sm text-gray-500">
      <p>This is a computer-generated document. No signature is required.</p>
      <p className="mt-1">For any payroll queries, please contact the HR department.</p>
      <p className="text-sm text-gray-500">Generated: {formatDate(generatedDate || new Date().toISOString())}</p>
    </div>
  );
};
